import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/fonts/fonts.css';
import Arise4uBlackLogo from '../../assets/images/arise logo-01 1.svg';
import StudentDetailsPage from '../sections/StudentDetailsPage';
import '../../assets/styles/paymentsuccess.css';

const PaymentSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search);
  const txnid = query.get('txnid') || '-';
  const status = query.get('status') || '-';

  const [isStudentUpdated, setIsStudentUpdated] = useState(false);

  const handleBackToHome = () => {
    navigate('/');
  };

  return (
    <div className="container py-4">
      <div className="text-center mb-4">
        <img
          src={Arise4uBlackLogo}
          alt="Arise4u Black Logo"
          className="mb-3 payment-success-logo"
          style={{ width: "150px" }}
        />
       {!isStudentUpdated && (
    <h2 className="font-bold fs-1 text-success payment-success-header">
      Thank you! Your payment was successful.
    </h2>
  )}

        
      </div>

      {isStudentUpdated ? (
        <>
          {/* Confirmation Card */}
          <div
            className="cards p-4 shadow mx-auto mb-3"
            style={{
              maxWidth: '750px',
              borderRadius: '12px',
            }}
          >
            {/* “You are all Set” inside the box */}
            <h3 className="font-bold fs-3 text-success text-center mb-3 confirmation-header"> {/* Added custom class */}
              You are all set
            </h3>

            <div
              className="confirmation-message" // Added custom class
              style={{
                textAlign: 'center',
                // maxWidth: '600px',
                margin: '0 auto 20px auto',
                padding: '15px',
                borderRadius: '12px',
                backgroundColor: '#f8f9fa',
              }}
            >
              <p
                className="font-bold"
                style={{ margin: '8px 0', fontSize: '1.5rem', color: '#333' }}
              >
                Keep an eye on your inbox - you'll receive more details from us within 24 hours.
              </p>
              <p
                className="font-bold"
                style={{ margin: '8px 0', fontSize: '1.5rem', color: '#333' }}
              >
              For any questions, please reach out to our team at
              </p>
              <p
                className="font-bold"
                style={{
                  margin: '8px 0',
                  fontSize: '1.5rem',
                  color: '#007bff',
                  fontWeight: '600',
                }}
              >
                <a
                  href="mailto:admin@ariseforyou.com"
                  style={{ color: '#007bff', textDecoration: 'none' }}
                >
                  support@ariseforyou.com
                </a>
              </p>
            </div>

            {/* Transaction Details Box */}
            {/* <div
              className="card transaction-details-card" // Added custom class
              style={{
                marginTop: '20px',
                padding: '15px',
                borderRadius: '12px',
              }}
            >
              <h5 className="font-bold fs-6 mb-2">Transaction Details</h5>
              <p className="mb-2">
                <strong>Transaction ID:</strong> {txnid}
              </p>
              <p className="mb-2">
                <strong>Status:</strong> {status}
              </p>
              <p className="mb-2">
                <strong>Amount:</strong> Rs. 2,990/- (incl GST)
              </p>
            </div> */}
          </div>

          {/* Back to Home Button */}
          <div className="text-center">
            <button
              className="btn btn-primary mt-3 font-regular-four fs-5 back-home-button"
              onClick={handleBackToHome}
              style={{ marginBottom: '60px' }}
            >
              Back to Home
            </button>
          </div>
        </>
      ) : (
        <>
        
          <div
            className="card transaction-details-card" // Added custom class
            style={{
              marginTop: '20px',
              padding: '15px',
              borderRadius: '12px',
              justifyContent:'center',
            }}
          >
            <h5 className="font-bold fs-6 mb-2">Transaction Details</h5>
            <p className="mb-2">
              <strong>Transaction ID:</strong> {txnid}
            </p>
            <p className="mb-2">
              <strong>Status:</strong> {status}
            </p>
            <p className="mb-2">
              <strong>Amount:</strong> Rs. 2,990/- (incl GST)
            </p>
          </div>
          {!isStudentUpdated && (
          <div className="alert alert-info text-center py-3 payment-success-alert" role="alert" style={{ marginTop:"10px" ,}}>
            <h3 className="font-regular mb-0" style={{ fontSize: "1.5rem",}}>
              We just need a few more details to complete your profile and create your account.
            </h3>
          </div>
        )}
          <StudentDetailsPage setIsStudentUpdated={setIsStudentUpdated} /></>
      )}
    </div>
  );
};

export default PaymentSuccess;